@let recurring = detail();
<app-drawer-layout
  [title]="recurring?.merchantIdentity?.displayName ?? 'Recurring transaction'"
  [subtitle]="recurring ? 'Expected ' + (recurring.expectedDate | date: 'longDate') : undefined"
  [state]="recurring ? 'ready' : detailQuery.isError() ? 'error' : 'loading'"
  loadingMessage="Loading recurring transaction…"
  errorMessage="We couldn't load this recurring transaction."
>
  <!-- Single-root @if blocks so each piece is projected into its slot. -->
  @if (recurring) {
    <app-merchant-avatar
      drawerLeading
      size="md"
      [name]="recurring.merchantIdentity.displayName"
      [logoUrl]="recurring.merchantIdentity.logoUrl"
    />
  }
  @if (recurring) {
    <div class="flex flex-col gap-8">
      <app-drawer-section heading="Summary">
        <dl class="m-0 divide-y divide-border-muted text-body-sm">
          <div class="flex items-center justify-between gap-6 px-4 py-3">
            <dt class="text-text-muted">Expected amount</dt>
            @let expectedAmount = amount(recurring);
            <dd class="m-0 font-bold tabular-nums text-text-title">
              @if (expectedAmount !== null) {
                {{ recurring.direction === 'INCOME' ? '+' : ''
                }}{{ expectedAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
              } @else {
                Not available
              }
            </dd>
          </div>
          <div class="flex items-center justify-between gap-6 px-4 py-3">
            <dt class="text-text-muted">Frequency</dt>
            <dd class="m-0 font-semibold text-text-title">{{ cadenceLabel(recurring.cadence) }}</dd>
          </div>
          <div class="flex items-center justify-between gap-6 px-4 py-3">
            <dt class="text-text-muted">Amount type</dt>
            <dd class="m-0 font-semibold text-text-title">{{ amountBehaviorLabel(recurring) }}</dd>
          </div>
          <div class="flex items-center justify-between gap-6 px-4 py-3">
            <dt class="text-text-muted">Payment source</dt>
            @let paymentSources = paymentSourceLabels(recurring);
            <dd class="m-0 max-w-recurring-payment-source text-right font-semibold text-text-title">
              @if (paymentSources.length > 0) {
                @for (paymentSource of paymentSources; track paymentSource) {
                  <span class="block truncate">{{ paymentSource }}</span>
                }
              } @else {
                Not available
              }
            </dd>
          </div>
        </dl>
      </app-drawer-section>

      <section class="flex flex-col gap-2" aria-labelledby="matched-transactions-title">
        <header class="flex items-end justify-between gap-4 px-1">
          <div>
            <h3
              id="matched-transactions-title"
              class="m-0 text-xs font-extrabold uppercase tracking-eyebrow text-text-muted"
            >
              Transactions
            </h3>
            <p class="m-0 mt-0.5 text-xs text-text-muted">
              {{ recurring.matchedTransactions.length }} used to identify this pattern
            </p>
          </div>
          <p class="m-0 text-xs font-bold tabular-nums text-text-muted">
            {{ totalMatched(recurring) | currency: 'USD' : 'symbol' : '1.2-2' }} total
          </p>
        </header>

        @if (recurring.matchedTransactions.length > 0) {
          <div class="overflow-hidden rounded-lg border border-border bg-surface-elevated">
            @for (transaction of matchedTransactionsNewestFirst(recurring); track transaction.id) {
              <div
                class="border-b border-border-muted bg-surface-muted px-4 py-2 text-transaction-date-header font-semibold uppercase tracking-eyebrow text-text-muted"
              >
                {{ transaction.date | date: 'mediumDate' }}
              </div>
              <div class="h-transaction-row [&>*]:box-border [&>*]:h-full">
                <app-transaction-list-item
                  [transaction]="matchedTransaction(transaction)"
                  [bucketIdentities]="bucketIdentities()"
                  [interactive]="false"
                  [showBucketSelector]="false"
                />
              </div>
            }
          </div>
        } @else {
          <div class="rounded-lg border border-border bg-surface-elevated p-4 text-body-sm text-text-muted">
            No matched transactions are available.
          </div>
        }
      </section>
    </div>
  }
</app-drawer-layout>
